export default __webpack_public_path__ + "static/media/wifi-2.2ef8f6ee.svg";